// extracted by mini-css-extract-plugin
export default {"FAQHeader":"FAQHeader_FAQHeader__1WEmu","headerTitle":"FAQHeader_headerTitle__wra3L","searchBar":"FAQHeader_searchBar__PQ5JE"};